import React from 'react';
import Socials from "@/components/layout/Socials";

interface IntroProps {
  position?: 'left' | 'right';
}

export const Intro: React.FC<IntroProps> = ({ position = 'right' }) => {
  return (
    <section 
      id="intro" 
      className="relative min-h-screen flex items-center justify-center pt-20 pb-16 bg-background"
    >
      <div className="container px-4 md:px-6 relative z-10">
        <div 
          className={`grid grid-cols-1 md:grid-cols-2 gap-8 items-center ${
            position === 'left' ? 'md:flex-row-reverse' : ''
          }`}
        >
          {/* Text Column */}
          <div className="space-y-6 text-center md:text-left">
            <h1 className="text-5xl md:text-6xl font-bold text-text mb-2">
              Zein Alamah
            </h1>

            <p className="text-base md:text-lg text-text/80 max-w-xl mx-auto md:mx-0">
              Hello. I’m <a href="/about" className="text-primary hover:text-primary/80"><strong>Zein Alamah</strong></a>, a Financial Economist and PhD candidate in Economics at Concordia University. I hold an MSc in Finance and an MA in Applied Economics. As a tech enthusiast, I'm biased toward computational methods and data-driven decision-making.
              <br /><br />
              This site is a work in progress, built gradually in my spare time to share ideas, projects, and <a href="/research" className="text-primary hover:text-primary/80">ongoing research</a>.
              <br /><br />
              Explore my <a href="/blog" className="text-primary hover:text-primary/80">Blog</a> or subscribe to the <a 
                href="https://zeinalamah.substack.com/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-primary hover:text-primary/80"
              >Newsletter</a> for updates and insights.
              <br /><br />
              Thanks for stopping by! Feel free to reach out if you'd like to connect.
            </p>


            <div className="flex justify-center md:justify-start gap-4 pt-4">
              <Socials />
            </div>
          </div>
          {/* Image Column */}
          <div className="flex justify-center md:justify-end">
            <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-blue-600/20 shadow-xl">
              <img
                src="/zein-alamah.webp"
                alt="Zein Alamah"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
